import { Component } from '@angular/core';
import { AccountSetupHelperService } from '../../account-setup-helper.service';
import { SharedProfileService } from 'src/app/components/profile/shared-profile.service';

@Component({
  selector: 'app-hub-instructor-step',
  templateUrl: './hub-instructor-step.component.html',
  styleUrls: ['./hub-instructor-step.component.css'],
})
export class HubInstructorStepComponent {
  bioTrigger = 0;

  constructor(
    public accountSetupHelperService: AccountSetupHelperService,
    sharedProfileService: SharedProfileService,
  ) {
    if (
      !this.accountSetupHelperService.wizardData.hubInput.hubInstructor.fullName
    ) {
      this.accountSetupHelperService.wizardData.hubInput.hubInstructor.fullName =
        `${sharedProfileService.currentUser?.firstName} ${sharedProfileService.currentUser?.lastName}` ||
        '';
    }
    if (
      !this.accountSetupHelperService.wizardData.hubInput.hubInstructor.email
    ) {
      this.accountSetupHelperService.wizardData.hubInput.hubInstructor.email =
        sharedProfileService.currentUser?.email || '';
    }
  }

  triggerBioGenerate() {
    this.bioTrigger++;
  }
  getInitials(name: string): string {
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  }

  get bioPrompt() {
    return `Write a bio for a hub instructor with the following details: 
    
    ## Full Name
    ${this.accountSetupHelperService.wizardData.hubInput.hubInstructor.fullName}
    
    ## Title/Role
    ${this.accountSetupHelperService.wizardData.hubInput.hubInstructor.title}

    ${
      this.accountSetupHelperService.wizardData.hubInput.hubInstructor.bio
        ? `## Current Bio
    ${this.accountSetupHelperService.wizardData.hubInput.hubInstructor.bio}`
        : ''
    }

    Provide 40–80 words, written in 1–2 short paragraphs. Don't use any kind of formatting.
    `;
  }

  onStepDone() {}
}
